/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
    addNewCompetency,
    editCompetency,
    getAllCompetenecies
} from "../../api/apiCall";
import { useAuth } from "../../auth/auth";
import { format } from "date-fns";
import { toast } from "react-toastify";

const Competencies = () => {
    const {state} = useAuth();
    const [competencies, setComptenecies] = useState<any>([]);
    const handleAddRow = () => {
        const newRow = {
            id: competencies.length + 1,
            name: ``
        };
        setComptenecies((prevRows: any) => [newRow, ...prevRows]);
    };

    const handleChange = (id: any, field: any, newValue: any) => {
        const updatedRows = competencies.map((row: any) =>
          row.id === id ? { ...row, [field]: newValue } : row
        );
        setComptenecies(updatedRows);
    };

    const columns: any = [
        {
            field: "skillName",
            headerName: "Competency",
            flex: 1,
            renderCell: (params: any) => (
                <TextField
                    size="small"
                    value={params.row.skillName}
                    fullWidth
                    style={{ height: "5px", margin: 5 }}
                    onChange={(event: any) => {
                        handleChange(params.id, "skillName", event.target.value);
                    }}
                    inputProps={{
                        ...params.inputProps,
                        onKeyDown: (event) => {
                            if (event.key === ' ') {
                                event.stopPropagation();
                            }
                        },
                    }}
                />
              ),
        },
        {
            field: "createdDate",
            headerName: "Added Date",
            flex: 0.5,
            renderCell: (params: any) => (
                <div>
                    {format(new Date(params.row.addedDate || Date.now()), 'dd/MM/yyyy')}
                </div>
            ),
        },
        {
            field: "save",
            headerName: "Save",
            flex: 0.3,
            renderCell: (params: any) => (
                <Button
                    variant="outlined"
                    onClick={() => handleCellEditCommit(params)}
                >
                    Save
                </Button>
            )
        }
    ];

    const handleCellEditCommit = async (params: any) => {
        if(typeof params.row.id === 'number') {
            const response = await addNewCompetency(state.user?.token, params.row.skillName)
            if(response) {
                toast.success(response.data);
                getAllCompetenecies(state.user?.token).then(setComptenecies);
            } else {
                toast.error('Something went wrong!')
            }
        } else {
            const response = await editCompetency(state.user?.token, params.row.id, params.row.skillName)
            if(response) {
                toast.success(response.data);
            } else {
                toast.error('Something went wrong!')
            }
        }
    };

    useEffect(() => {
        getAllCompetenecies(state.user?.token).then(setComptenecies);
    }, [])

    return (
        <div>
            <div className="add-button">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddRow}
                    style={{boxShadow: 'none'}}
                >
                    Add Competency
                </Button>
            </div>
            <Box
                sx={{
                    width: "70%",
                    height: '840px',
                    margin: "0 auto",
                    mt: 4,
                    "@media (max-width: 800px)": {
                        overflowX: "auto",
                        margin: 1,
                        minWidth: "95%",
                    },
                }}
            >
                <DataGrid
                    rows={competencies}
                    columns={columns}
                    disableRowSelectionOnClick
                    sx={{
                        "@media (max-width: 700px)": {
                            minWidth: "100%",
                        },
                        "& .MuiDataGrid-columnHeader": {
                            color: "#333",
                            fontWeight: "bold",
                            fontSize: 15,
                            backgroundColor: '#f0f0f0',
                        },
                        "& .MuiDataGrid-columnHeaderTitle": {
                            fontWeight: "bold",
                        },
                        "& .MuiDataGrid-row:hover": {
                            backgroundColor: "#f1f1f1",
                        },
                    }}
                />
            </Box>
        </div>
    );
};

export default Competencies;
